var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex",class:_vm.localClasses['container'],style:(_vm.styles['container'])},[_c('v-pagination',{attrs:{"color":_vm.color,"length":_vm.localTotalPage,"circle":_vm.circle},model:{value:(_vm.localPage),callback:function ($$v) {_vm.localPage=$$v},expression:"localPage"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }